<div style="display:none">{{changeDetect|async}}</div>
  <table id={{id}} mat-table [dataSource]="data | async" recycleRows [trackBy]="trackDataRow">
    <ng-container matColumnDef="0">
      <th mat-header-cell *matHeaderCellDef>{{to.label}}</th>
      <td style="width: 175px; pointer-events: none;" mat-cell *matCellDef="let row">{{row.label}}</td>
    </ng-container>
    <div *ngFor="let col of columns | async; let i=index;">
      <ng-container *ngIf="col.value !== '0'" [matColumnDef]="col.value">
        <th mat-header-cell *matHeaderCellDef>{{columnLabel(i)}}</th>
        <td mat-cell *matCellDef="let assessment" style="text-align: center;"> 
          <mat-radio-button [name]="assessment.id" value={{i}} [checked]="assessment.rating == i"
            (change)="radioChange($event,assessment)" disableRipple=true [disabled]="formControl.disabled"></mat-radio-button>
        </td>
      </ng-container>
    </div>
    <tr mat-header-row *matHeaderRowDef="columnIds | async sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columnIds | async;"></tr>
  </table>
